import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT



//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/givecouponlog/list', qs.stringify(params))
}


//获取列表数据
export const couponLogSave = (params) => {
  return axios.post(root+'/set/givecouponlog/save', qs.stringify(params))
}





// WEBPACK FOOTER //
// ./src/api/set/givecouponlog.js